export const createKey = str => str.replace(/ /g, '_').toLowerCase();
